import axios from "axios";
import {
  linkRedirectsNeedSubscriberKey,
  needsSubscriberKeyFetch,
  resolveFromHistory,
} from "@/services/programLinks";

/**
 * Complements FORGE-486 v3 (billingSubscriberKey from SF via pgsf when sfId
 * is present). This service resolves the same key for organic clients by
 * calling lambda-email-crypter over HTTP on the confirmation page only.
 *
 * URL : custom domain API Gateway par env (`crypter.*.pubfac.com`), configurée
 * via `env/.env.*` (`VUE_APP_EMAIL_CRYPTER_API_BASE_URL`). Pas de dérivation
 * depuis le domaine shop / marque.
 */
export function getEmailCrypterApiBaseUrl() {
  return process.env.VUE_APP_EMAIL_CRYPTER_API_BASE_URL || null;
}

export { linkRedirectsNeedSubscriberKey, needsSubscriberKeyFetch };

export async function fetchSubscriberKey(email) {
  const baseUrl = getEmailCrypterApiBaseUrl();
  if (!baseUrl) {
    throw new Error("EMAIL_CRYPTER_API_BASE_URL is not configured");
  }

  const response = await axios.post(
    `${baseUrl}/subscriber-key`,
    { email },
    { timeout: 10000 },
  );

  const subscriberKey = response.data?.subscriberKey;
  if (!subscriberKey || typeof subscriberKey !== "string") {
    throw new Error("subscriberKey missing from email-crypter response");
  }

  return subscriberKey;
}

export function getBillingEmailFromHistory(history) {
  return resolveFromHistory(history, "billingEmail");
}
